'use client';

import { useEffect } from 'react';

export default function DashboardError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Dashboard error:', error);
  }, [error]);

  return (
    <div
      className="flex flex-col items-center justify-center min-h-[400px] p-8"
      style={{ backgroundColor: '#eeeced' }}
    >
      <h2 className="text-foreground font-heading font-bold text-xl mb-2">Something went wrong</h2>
      <p className="text-foreground/70 font-body text-sm mb-6 text-center max-w-md">
        The dashboard couldn’t load. This can happen after a refresh or when the app is still starting.
      </p>
      <button
        onClick={reset}
        className="px-6 py-3 rounded-lg font-medium text-white transition-colors"
        style={{ backgroundColor: '#002b1b' }}
      >
        Try again
      </button>
    </div>
  );
}
